import { useQuery } from "@tanstack/react-query";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IExportColumnField } from "common/models/IExportColumn";

export function useGetExportFields(groupName: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ["exportFields", groupName],
    queryFn: async () => {
      const response = await api.post<IExportColumnField[]>(
        endpoints.dataExportField.selectExportColumnsByGroupName,
        { groupName },
      );
      return response?.apiData || [];
    },
    enabled: !!groupName && enabled,
    staleTime: 5 * 60 * 1000,
  });
}
